import * as React from 'react'
import * as classNames from 'classnames'
import * as Yup from 'yup'
import { History } from 'history'
import { Field, FieldProps, Formik, FormikProps } from 'formik'
import { yupNumberStrong } from '../../../../../../utils/yup'
import { IAddOn, IProductPricing, IProviderProductObject } from '../../../../../../types/index'
import EditBottom from '../EditBottom'
import UIMessages from 'src/utils/ui-messages'
import WorkingTime from 'src/components/services/edit/WorkingTime'
import moment from 'moment'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import { IFormValues } from 'src/components/assistance/AddAsistanceForm/AddAssistanceCreateForm'
import { Input } from '@mobiscroll/react-latest'
import Close from 'src/components/icons/drivers/Close'
import { withNotification } from 'src/components/ui/notification-provider'
import history from 'src/history'

interface IProductPricingFormProps {
  pricing: IProductPricing
  product: IProviderProductObject
  formRef: (node: any) => void
  saveProduct: (product: IProviderProductObject) => Promise<any>
  notification?: any
  history?: History
}

interface IIntegrationFormState {
  isSaved: boolean
  isSaving: boolean
  currentAddOnLabel: string
  currentAddOnPrice: number
  addOnDisplay: IAddOn[] // for display only
  addOn: {} // this will be saved as a JSON object in the backend
  afterHoursFrom: string
  afterHoursUntil: string
  afterHoursFromDisplay: string
  afterHoursUntilDisplay: string
  addonPrice: number // default for addon price
  displayAddon: number // value for displaying 0 zero price
  autoRoundUp: boolean
}

class ProviderProductPricingForm extends React.Component<IProductPricingFormProps, IIntegrationFormState> {
  public validationSchema = Yup.object().shape({
    basePrice: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Base price is required'),
    baseDistance: yupNumberStrong()
      .min(0, '0 miles is the minimum value')
      .max(100, '100 miles is the max value')
      .required('Base miles is required is required'),
    perMilePrice: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    perMinutePrice: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    cancellationPrice: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Cancellation price is required'),
    surcharges: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    stateTax: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(100, 'Wrong value'),
    federalTax: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(100, 'Wrong value'),
    surgeMultiple: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(100, 'Wrong value'),
    noShowPrice: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('No show price is required'),
    basePriceAddOnAH: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Base price is required'),
    minimumMilesAddOnAH: yupNumberStrong()
      .min(0, '0 miles is the minimum value')
      .max(100, '100 miles is the max value')
      .required('Base miles is required is required'),
    perMilePriceAddOnAH: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    perMinutePriceAddOnAH: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    surChargeAddOnAH: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Cancellation price is required'),
    lateCancellationAddOnAH: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    noShowAddOnAH: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('No show price is required'),
    basePriceAddOnWE: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Base price is required'),
    minimumMilesAddOnWE: yupNumberStrong()
      .min(0, '0 miles is the minimum value')
      .max(100, '100 miles is the max value')
      .required('Base miles is required is required'),
    perMilePriceAddOnWE: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    perMinutePriceAddOnWE: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    surChargeAddOnWE: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Cancellation price is required'),
    lateCancellationAddOnWE: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    noShowAddOnWE: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('No show price is required'),

    basePriceAddOnHD: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Base price is required'),
    minimumMilesAddOnHD: yupNumberStrong()
      .min(0, '0 miles is the minimum value')
      .max(100, '100 miles is the max value')
      .required('Base miles is required is required'),
    perMilePriceAddOnHD: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    perMinutePriceAddOnHD: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    surChargeAddOnHD: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('Cancellation price is required'),
    lateCancellationAddOnHD: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value'),
    noShowAddOnHD: yupNumberStrong()
      .min(0, 'Wrong value')
      .max(10000, 'Wrong value')
      .required('No show price is required')
  })
  private pricingRef: any

  constructor(props: IProductPricingFormProps) {
    super(props)

    this.state = {
      isSaved: false,
      isSaving: false,
      currentAddOnLabel: '',
      currentAddOnPrice: 0,
      addOnDisplay: [], // for displaying only
      addOn: {}, // this will be saved as a JSON object in the backend
      afterHoursFrom: moment()
        .hours(22)
        .minutes(0)
        .toISOString(),
      afterHoursUntil: moment()
        .hours(6)
        .minutes(0)
        .toISOString(),
      afterHoursFromDisplay: '16:00',
      afterHoursUntilDisplay: '6:00',
      addonPrice: 0,
      displayAddon: 0,
      autoRoundUp: true
    }
  }

  public componentDidMount() {
    if (this.props.pricing.addOn) {
      let addOn = {}
      this.props.pricing.addOn.forEach((item: IAddOn) => {
        addOn = { ...addOn, [`${item.label}`]: item.price }
      })
      this.setState({ addOnDisplay: this.props.pricing.addOn, addOn })
    }
    if (this.props.pricing.afterHoursFrom && this.props.pricing.afterHoursUntil) {
      this.setState({
        afterHoursFrom: moment(this.props.pricing.afterHoursFrom).toISOString(),
        afterHoursUntil: moment(this.props.pricing.afterHoursUntil).toISOString(),
        afterHoursFromDisplay: moment(this.props.pricing.afterHoursFrom).format('HH:mm'),
        afterHoursUntilDisplay: moment(this.props.pricing.afterHoursUntil).format('HH:mm')
      })
    }
    const autoRoundUpFromDB =
      this.props.pricing && this.props.pricing.autoRoundUp !== undefined ? this.props.pricing.autoRoundUp : false
    this.setState({ autoRoundUp: autoRoundUpFromDB })
  }

  public render() {
    const { product, pricing, history } = this.props
    const {
      isSaving,
      isSaved,
      addOnDisplay,
      afterHoursFromDisplay,
      afterHoursUntilDisplay,
      currentAddOnLabel,
      currentAddOnPrice
    } = this.state
    const clone: IProductPricing = { ...pricing }
    Object.keys(clone).map((field: string) => {
      if (!['baseDistance', 'minimumMilesAddOnWE', 'minimumMilesAddOnAH'].includes(field)) {
        clone[field] = clone[field] / 100
      }
    })

    return (
      <div>
        <FloatingForm fullHeight={true}>
          <>
            <div className='form-modal-section full-section'>
              <section>
                <Formik
                  initialValues={{
                    basePrice: clone.basePrice,
                    perMilePrice: clone.perMilePrice,
                    perMinutePrice: clone.perMinutePrice,
                    cancellationPrice: clone.cancellationPrice,
                    surcharges: clone.surcharges,
                    surgeMultiple: clone.surgeMultiple,
                    noShowPrice: clone.noShowPrice,
                    stateTax: clone.stateTax,
                    federalTax: clone.federalTax,
                    baseDistance: clone.baseDistance,
                    basePriceAddOnAH: clone.basePriceAddOnAH,
                    minimumMilesAddOnAH: clone.minimumMilesAddOnAH,
                    perMilePriceAddOnAH: clone.perMilePriceAddOnAH,
                    perMinutePriceAddOnAH: clone.perMinutePriceAddOnAH,
                    surChargeAddOnAH: clone.surChargeAddOnAH,
                    lateCancellationAddOnAH: clone.lateCancellationAddOnAH,
                    noShowAddOnAH: clone.noShowAddOnAH,
                    basePriceAddOnWE: clone.basePriceAddOnWE,
                    minimumMilesAddOnWE: clone.minimumMilesAddOnWE,
                    perMilePriceAddOnWE: clone.perMilePriceAddOnWE,
                    perMinutePriceAddOnWE: clone.perMinutePriceAddOnWE,
                    surChargeAddOnWE: clone.surChargeAddOnWE,
                    lateCancellationAddOnWE: clone.lateCancellationAddOnWE,
                    noShowAddOnWE: clone.noShowAddOnWE,
                    basePriceAddOnHD: clone.basePriceAddOnHD,
                    minimumMilesAddOnHD: clone.minimumMilesAddOnHD,
                    perMilePriceAddOnHD: clone.perMilePriceAddOnHD,
                    perMinutePriceAddOnHD: clone.perMinutePriceAddOnHD,
                    surChargeAddOnHD: clone.surChargeAddOnHD,
                    lateCancellationAddOnHD: clone.lateCancellationAddOnHD,
                    noShowAddOnHD: clone.noShowAddOnHD
                  }}
                  ref={this.pricingFormRef}
                  validationSchema={this.validationSchema}
                  onSubmit={this.onSave}
                  onChange={this.handleChange}
                  render={InnerForm()}
                />
              </section>
              <div className='pt2'>
                <section>
                  <div className='flex flex-row'>
                    <div className='col-3 pr2 font-grey3 h6'>From - Until</div>
                    <div className='col-3 pr2' />
                    <div className='col-3 pr2' />
                    <div className='col-3 pr2' />
                  </div>
                  <div className='flex flex-row items-center'>
                    <div className='col-3 pr2 full-width-datepicker'>
                      <WorkingTime
                        from={afterHoursFromDisplay}
                        type='long'
                        until={afterHoursUntilDisplay}
                        onTimeSet={this.handleSelectTime}
                      />
                    </div>
                    <div className='col-3 pr2' />
                    <div className='col-3 pr2' />
                    <div className='col-3 pr2' />
                    <div className='col-3 pr2' />
                  </div>
                </section>

                <section>
                  <hr className='my2' />
                  <div>
                    <div className='font-grey2 bold h5 mb1'>Create Add On</div>
                  </div>
                  <div className='flex flex-row mt1'>
                    <div className='col-3 pr2'>
                      <Input
                        name='addOnLabel'
                        id='addOnLabel1'
                        type='text'
                        onChange={this.setAddOnLabel}
                        value={this.state.currentAddOnLabel}
                        className='mobiscroll-input form'
                        label={UIMessages.rider.payment.addOnLabel}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                      />
                    </div>
                    <div className='col-3 pr2'>
                      <Input
                        name='addOnPrice'
                        type='number'
                        min={0}
                        id='addOnPrice1'
                        onChange={this.setAddOnPrice}
                        onKeyDown={(e: any) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                        value={`${this.state.displayAddon}`}
                        className='mobiscroll-input form'
                        label={UIMessages.rider.payment.addOnPrice}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                      />
                    </div>
                    {this.state.currentAddOnLabel.trim() !== '' ? (
                      <div className='col-3 pr2 flex items-center'>
                        <button className='custom-btn mbsc-green-btn' onClick={this.setAddOn}>
                          {UIMessages.rider.payment.addOnCreate}
                        </button>
                      </div>
                    ) : (
                      <div className='col-3 pr2 flex items-center'>
                        <button className='custom-btn mbsc-gray-btn' disabled={true}>
                          {UIMessages.rider.payment.addOnCreate}
                        </button>
                      </div>
                    )}

                    <div className='col-3 pr2' />
                    <div className='col-3 pr2' />
                  </div>
                </section>

                {addOnDisplay.length > 0 && (
                  <section>
                    <div className='mt1'>
                      <div>
                        <div className='font-grey2 bold h5 mb1'>Add Ons</div>
                      </div>
                      {addOnDisplay.map((item: IAddOn, index: number) => {
                        const price = item.price / 100

                        return (
                          <span className='product-item' key={item.label} style={{ whiteSpace: 'nowrap' }}>
                            {item.label} ( ${price.toFixed(2)} )
                            <span className='flex items-center' onClick={() => this.deleteAddOn(item.label, index)}>
                              <Close className='icon--9x9 ml1 cursor--pointer' />
                            </span>
                          </span>
                        )
                      })}
                    </div>
                  </section>
                )}
              </div>
            </div>
          </>
        </FloatingForm>

        <EditBottom
          isSaving={isSaving}
          cancelPath={`/products/${product.id}/pricing`}
          onSave={this.onSave}
          history={history}
        />
      </div>
    )
  }

  private handleSelectTime = (type: string, selectedTime: string) => {
    const time = selectedTime.split(':')
    const timeISO = moment()
      .hours(parseInt(time[0], 10))
      .minutes(parseInt(time[1], 10))
      .toISOString()

    type === 'from'
      ? this.setState({
          afterHoursFromDisplay: selectedTime,
          afterHoursFrom: timeISO
        })
      : this.setState({
          afterHoursUntilDisplay: selectedTime,
          afterHoursUntil: timeISO
        })
  }

  private pricingFormRef = (node: any) => {
    this.pricingRef = node
  }

  private handleChange(args: any) {
    console.log('on change: ', args)
  }

  private setAddOnLabel = (e: any) => {
    this.setState({
      currentAddOnLabel: e.target.value
    })
  }

  private setAddOnPrice = (e: any) => {
    const newValue = e.target.value.replace(/[-e]/gi, '')
    this.setState({
      currentAddOnPrice: parseFloat(newValue) * 100,
      displayAddon: newValue
    })
  }

  private setAddOn = (e: any) => {
    let addOnList = {}
    this.state.addOnDisplay.forEach((item: IAddOn) => {
      addOnList = { ...addOnList, [`${item.label}`]: item.price }
    })

    this.setState(
      {
        addOnDisplay: this.state.addOnDisplay.concat([
          { label: this.state.currentAddOnLabel, price: this.state.currentAddOnPrice }
        ]),
        addOn: { ...addOnList, [`${this.state.currentAddOnLabel}`]: this.state.currentAddOnPrice }
      },
      () =>
        this.setState({
          currentAddOnLabel: '',
          displayAddon: 0,
          currentAddOnPrice: 0
        })
    )
  }

  private deleteAddOn = (addOnLabel: string, index: number) => {
    console.log(addOnLabel, index)
    console.log(this.state.addOnDisplay)
    const addOnDisplay = this.state.addOnDisplay.filter(
      (item: IAddOn, addOnIndex: number) => item.label !== addOnLabel || addOnIndex !== index
    )
    console.log(addOnDisplay)
    let addOn = {}
    addOnDisplay.forEach((item: IAddOn) => {
      addOn = { ...addOn, [`${item.label}`]: item.price }
    })
    this.setState({ addOnDisplay, addOn })
  }

  private onSave = () => {
    const { values, errors } = this.pricingRef.state
    const { product, saveProduct, notification } = this.props
    const { addOn, afterHoursFrom, afterHoursUntil, autoRoundUp } = this.state
    if (Object.keys(errors).length > 0) {
      return
    }
    let { serviceLevelId } = product
    if (!serviceLevelId && product.providerServiceLevel) {
      serviceLevelId = product.providerServiceLevel.id
    }
    const clone = { ...values }
    Object.keys(clone).map((field: string) => {
      if (!['baseDistance', 'minimumMilesAddOnWE', 'minimumMilesAddOnAH'].includes(field)) {
        clone[field] = clone[field] * 100
      }
    })
    const updatedProduct = Object.assign({}, product, {
      pricing: {
        id: product.pricingId,
        addOn,
        afterHoursFrom,
        afterHoursUntil,
        autoRoundUp: Boolean(this.state.autoRoundUp),
        ...clone
      },
      serviceLevelId
    })
    saveProduct(updatedProduct)
      .then(response => {
        notification.addNotification({
          title: 'Successfully updated product!',
          level: 'success'
        })
      })
      .catch(error => {
        console.error('Failed to update product: ', error)
        notification.addNotification({
          title: 'Failed to update product.',
          level: 'error'
        })
      })

    history.push(`/products/${product.id}/pricing`)
  }
}

export default withNotification(ProviderProductPricingForm)

interface InnerFormValues {
  basePrice: number
  perMilePrice: number
  perMinutePrice: number
  cancellationPrice: number
  surcharges: number
  surgeMultiple: number
  noShowPrice: number
  stateTax: number
  federalTax: number
  baseDistance: number
  basePriceAddOnAH: number
  minimumMilesAddOnAH: number
  perMilePriceAddOnAH: number
  perMinutePriceAddOnAH: number
  surChargeAddOnAH: number
  lateCancellationAddOnAH: number
  noShowAddOnAH: number
  basePriceAddOnWE: number
  minimumMilesAddOnWE: number
  perMilePriceAddOnWE: number
  perMinutePriceAddOnWE: number
  surChargeAddOnWE: number
  lateCancellationAddOnWE: number
  noShowAddOnWE: number
  basePriceAddOnHD: number
  minimumMilesAddOnHD: number
  perMilePriceAddOnHD: number
  perMinutePriceAddOnHD: number
  surChargeAddOnHD: number
  lateCancellationAddOnHD: number
  noShowAddOnHD: number
}

const InnerForm = () => (props: FormikProps<InnerFormValues>) => {
  const { touched, errors } = props

  const textInput = ({ field }: FieldProps<IFormValues>, label: string, error: boolean = false) => {
    return (
      <Input
        type='number'
        min={0}
        {...field}
        className={classNames('mobiscroll-input form', {
          'border-red focus-red': error
        })}
        label={label}
        theme='ios'
        themeVariant='light'
        inputStyle='box'
        labelStyle='floating'
      />
    )
  }

  return (
    <form>
      <div className='font-grey2 bold h5 mb1'>Pricing</div>
      <div className='pt1'>
        <div className='flex flex-row'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='basePrice'
              render={field => textInput(field, 'Base Price', touched.basePrice && errors.basePrice)}
            />
            <div className='error'>
              {touched.basePrice && errors.basePrice && <span className='h6 font-red'>{errors.basePrice}</span>}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='baseDistance'
              render={field => textInput(field, 'Minimum miles', touched.baseDistance && errors.baseDistance)}
            />
            <div className='error'>
              {touched.baseDistance && errors.baseDistance && (
                <span className='h6 font-red'>{errors.baseDistance}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMilePrice'
              render={field => textInput(field, 'Price per mile', touched.perMilePrice && errors.perMilePrice)}
            />
            <div className='error'>
              {touched.perMilePrice && errors.perMilePrice && (
                <span className='h6 font-red'>{errors.perMilePrice}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMinutePrice'
              render={field => textInput(field, 'Price per minute', touched.perMinutePrice && errors.perMinutePrice)}
            />
            <div className='error'>
              {touched.perMinutePriceAddOnWE && errors.perMinutePriceAddOnWE && (
                <span className='h6 font-red'>{errors.perMinutePriceAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='cancellationPrice'
              render={field =>
                textInput(field, 'Late cancellation fee', touched.cancellationPrice && errors.cancellationPrice)
              }
            />
            <div className='error'>
              {touched.cancellationPrice && errors.cancellationPrice && (
                <span className='h6 font-red'>{errors.cancellationPrice}</span>
              )}
            </div>
          </div>
        </div>
        <div className='flex flex-row mt2'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='noShowPrice'
              render={field => textInput(field, 'No Show Fee', touched.noShowPrice && errors.noShowPrice)}
            />
            <div className='error'>
              {touched.noShowPrice && errors.noShowPrice && <span className='h6 font-red'>{errors.noShowPrice}</span>}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='surcharges'
              render={field => textInput(field, 'Surcharges', touched.surcharges && errors.surcharges)}
            />
            <div className='error'>
              {touched.surcharges && errors.surcharges && <span className='h6 font-red'>{errors.surcharges}</span>}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='stateTax'
              render={field => textInput(field, 'State tax %', touched.stateTax && errors.stateTax)}
            />
            <div className='error'>
              {touched.stateTax && errors.stateTax && <span className='h6 font-red'>{errors.stateTax}</span>}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='federalTax'
              render={field => textInput(field, 'Federal tax %', touched.federalTax && errors.federalTax)}
            />
            <div className='error'>
              {touched.federalTax && errors.federalTax && <span className='h6 font-red'>{errors.federalTax}</span>}
            </div>
          </div>
          <div className='col-3 pr2' />
        </div>
      </div>
      <hr className='my2' />
      <div className='font-grey2 bold h5 mb1'>Pricing Weekend</div>
      <div className='pt1'>
        <div className='flex flex-row'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='basePriceAddOnWE'
              render={field => textInput(field, 'Base Price', touched.basePriceAddOnWE && errors.basePriceAddOnWE)}
            />
            <div className='error'>
              {touched.basePriceAddOnWE && errors.basePriceAddOnWE && (
                <span className='h6 font-red'>{errors.basePriceAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='minimumMilesAddOnWE'
              render={field =>
                textInput(field, 'Minimum miles', touched.minimumMilesAddOnWE && errors.minimumMilesAddOnWE)
              }
            />
            <div className='error'>
              {touched.minimumMilesAddOnWE && errors.minimumMilesAddOnWE && (
                <span className='h6 font-red'>{errors.minimumMilesAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMilePriceAddOnWE'
              render={field =>
                textInput(field, 'Price per mile', touched.perMilePriceAddOnWE && errors.perMilePriceAddOnWE)
              }
            />
            <div className='error'>
              {touched.perMilePriceAddOnWE && errors.perMilePriceAddOnWE && (
                <span className='h6 font-red'>{errors.perMilePriceAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMinutePriceAddOnWE'
              render={field =>
                textInput(field, 'Price per minute', touched.perMinutePriceAddOnWE && errors.perMinutePriceAddOnWE)
              }
            />
            <div className='error'>
              {touched.perMinutePriceAddOnWE && errors.perMinutePriceAddOnWE && (
                <span className='h6 font-red'>{errors.perMinutePriceAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='lateCancellationAddOnWE'
              render={field =>
                textInput(
                  field,
                  'Late cancellation fee',
                  touched.lateCancellationAddOnWE && errors.lateCancellationAddOnWE
                )
              }
            />
            <div className='error'>
              {touched.lateCancellationAddOnWE && errors.lateCancellationAddOnWE && (
                <span className='h6 font-red'>{errors.lateCancellationAddOnWE}</span>
              )}
            </div>
          </div>
        </div>
        <div className='flex flex-row mt2'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='noShowAddOnWE'
              render={field => textInput(field, 'No Show Fee', touched.noShowAddOnWE && errors.noShowAddOnWE)}
            />
            <div className='error'>
              {touched.noShowAddOnWE && errors.noShowAddOnWE && (
                <span className='h6 font-red'>{errors.noShowAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='surChargeAddOnWE'
              render={field => textInput(field, 'Surcharges', touched.surChargeAddOnWE && errors.surChargeAddOnWE)}
            />
            <div className='error'>
              {touched.surChargeAddOnWE && errors.surChargeAddOnWE && (
                <span className='h6 font-red'>{errors.surChargeAddOnWE}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2' />
          <div className='col-3 pr2' />
          <div className='col-3 pr2' />
        </div>
      </div>
      <hr className='my2' />
      <div className='font-grey2 bold h5 mb1'>Pricing Holidays</div>
      <div className='pt1'>
        <div className='flex flex-row'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='basePriceAddOnHD'
              render={field => textInput(field, 'Base Price', touched.basePriceAddOnHD && errors.basePriceAddOnHD)}
            />
            <div className='error'>
              {touched.basePriceAddOnHD && errors.basePriceAddOnHD && (
                <span className='h6 font-red'>{errors.basePriceAddOnHD}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='minimumMilesAddOnHD'
              render={field =>
                textInput(field, 'Minimum miles', touched.minimumMilesAddOnHD && errors.minimumMilesAddOnHD)
              }
            />
            <div className='error'>
              {touched.minimumMilesAddOnHD && errors.minimumMilesAddOnHD && (
                <span className='h6 font-red'>{errors.minimumMilesAddOnHD}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMilePriceAddOnHD'
              render={field =>
                textInput(field, 'Price per mile', touched.perMilePriceAddOnHD && errors.perMilePriceAddOnHD)
              }
            />
            <div className='error'>
              {touched.perMilePriceAddOnHD && errors.perMilePriceAddOnHD && (
                <span className='h6 font-red'>{errors.perMilePriceAddOnHD}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMinutePriceAddOnHD'
              render={field =>
                textInput(field, 'Price per minute', touched.perMinutePriceAddOnHD && errors.perMinutePriceAddOnHD)
              }
            />
            <div className='error'>
              {touched.perMinutePriceAddOnHD && errors.perMinutePriceAddOnHD && (
                <span className='h6 font-red'>{errors.perMinutePriceAddOnHD}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='lateCancellationAddOnHD'
              render={field =>
                textInput(
                  field,
                  'Late cancellation fee',
                  touched.lateCancellationAddOnHD && errors.lateCancellationAddOnHD
                )
              }
            />
            <div className='error'>
              {touched.lateCancellationAddOnHD && errors.lateCancellationAddOnHD && (
                <span className='h6 font-red'>{errors.lateCancellationAddOnHD}</span>
              )}
            </div>
          </div>
        </div>
        <div className='flex flex-row mt2'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='noShowAddOnHD'
              render={field => textInput(field, 'No Show Fee', touched.noShowAddOnHD && errors.noShowAddOnHD)}
            />
            <div className='error'>
              {touched.noShowAddOnHD && errors.noShowAddOnHD && (
                <span className='h6 font-red'>{errors.noShowAddOnHD}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='surChargeAddOnHD'
              render={field => textInput(field, 'Surcharges', touched.surChargeAddOnHD && errors.surChargeAddOnHD)}
            />
            <div className='error'>
              {touched.surChargeAddOnHD && errors.surChargeAddOnHD && (
                <span className='h6 font-red'>{errors.surChargeAddOnHD}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2' />
          <div className='col-3 pr2' />
          <div className='col-3 pr2' />
        </div>
      </div>
      <hr className='my2' />
      <div className='font-grey2 bold h5 mb1'>Pricing after hours</div>
      <div className='pt1'>
        <div className='flex flex-row'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='basePriceAddOnAH'
              render={field => textInput(field, 'Base Price', touched.basePriceAddOnAH && errors.basePriceAddOnAH)}
            />
            <div className='error'>
              {touched.basePriceAddOnAH && errors.basePriceAddOnAH && (
                <span className='h6 font-red'>{errors.basePriceAddOnAH}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='minimumMilesAddOnAH'
              render={field =>
                textInput(field, 'Minimum miles', touched.minimumMilesAddOnAH && errors.minimumMilesAddOnAH)
              }
            />
            <div className='error'>
              {touched.minimumMilesAddOnAH && errors.minimumMilesAddOnAH && (
                <span className='h6 font-red'>{errors.minimumMilesAddOnAH}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMilePriceAddOnAH'
              render={field =>
                textInput(field, 'Price per mile', touched.perMilePriceAddOnAH && errors.perMilePriceAddOnAH)
              }
            />
            <div className='error'>
              {touched.perMilePriceAddOnAH && errors.perMilePriceAddOnAH && (
                <span className='h6 font-red'>{errors.perMilePriceAddOnAH}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='perMinutePriceAddOnAH'
              render={field =>
                textInput(field, 'Price per minute', touched.perMinutePriceAddOnAH && errors.perMinutePriceAddOnAH)
              }
            />
            <div className='error'>
              {touched.perMinutePriceAddOnAH && errors.perMinutePriceAddOnAH && (
                <span className='h6 font-red'>{errors.perMinutePriceAddOnAH}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='lateCancellationAddOnAH'
              render={field =>
                textInput(
                  field,
                  'Late cancellation fee',
                  touched.lateCancellationAddOnAH && errors.lateCancellationAddOnAH
                )
              }
            />
            <div className='error'>
              {touched.lateCancellationAddOnAH && errors.lateCancellationAddOnAH && (
                <span className='h6 font-red'>{errors.lateCancellationAddOnAH}</span>
              )}
            </div>
          </div>
        </div>
        <div className='flex flex-row mt2'>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='noShowAddOnAH'
              render={field => textInput(field, 'No Show Fee', touched.noShowAddOnAH && errors.noShowAddOnAH)}
            />
            <div className='error'>
              {touched.noShowAddOnAH && errors.noShowAddOnAH && (
                <span className='h6 font-red'>{errors.noShowAddOnAH}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2 flex flex-column undefined'>
            <Field
              name='surChargeAddOnAH'
              render={field => textInput(field, 'Surcharges', touched.surChargeAddOnAH && errors.surChargeAddOnAH)}
            />
            <div className='error'>
              {touched.surChargeAddOnAH && errors.surChargeAddOnAH && (
                <span className='h6 font-red'>{errors.surChargeAddOnAH}</span>
              )}
            </div>
          </div>
          <div className='col-3 pr2' />
          <div className='col-3 pr2' />
          <div className='col-3 pr2' />
        </div>
      </div>
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/components/products/details/product/edit/pane/ProductPricing.tsx